import { authSelector, isAppAuthSelector, isBillingAdminSelector } from './AuthSelectors';
import { CRM_ACCESS, CONTACTS_READ } from 'pricing-pages-lib/constants/Scopes';
export const hasScopeSelector = (state, scope) => {
  const auth = authSelector(state);
  return auth && auth.user && auth.user.scopes && auth.user.scopes.indexOf(scope) > -1 || false;
};
export const isDevPortalSelector = state => {
  const isApp = isAppAuthSelector(state);
  if (!isApp) return false;
  const doesntHaveCRMAccess = !hasScopeSelector(state, CRM_ACCESS) || !hasScopeSelector(state, CONTACTS_READ);
  const isBillingAdmin = isBillingAdminSelector(state);
  return doesntHaveCRMAccess && !isBillingAdmin;
};